import React, { Component } from 'react';
import { Progress, Icon, Spin, Modal } from 'antd';
import 'antd/dist/antd.css';


class FolderUploadProgress extends Component {

    closeModal = () => {
        const { uploadStatus } = this.props;
        if (uploadStatus == 'uploading') {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>上传尚未完成，要取消所有正在进行的上传吗？</div>,
                okText: '取消上传',
                cancelText: '继续上传',
                onOk: () => {
                    this.props.cancelBatchUpload();
                },
            });
        } else {
            this.props.resetAllSettings();
        }
    }

    render() {
        const {
            loading,
            folderName,
            uploadStatus,
            totalSize,
            completedSize,
            currentFileUploaded,
            totalFiles,
            uploadedFiles,
            failedFiles,
            currentFileIndex,
            selectedFiles,
            isProcessing,
        } = this.props;

        // 计算整体进度（已完成文件 + 当前文件已发送）
        const totalUploaded = completedSize + currentFileUploaded;
        const percentBySize = totalSize > 0 ? Math.min(Math.round((totalUploaded / totalSize) * 100), 100) : 0;
        const percentByFile = totalFiles > 0 ? Math.min(Math.round((uploadedFiles / totalFiles) * 100), 100) : 0;

        // 当前上传文件名
        let currentFileName = '未知文件';
        if (currentFileIndex >= 0 && selectedFiles && selectedFiles[currentFileIndex] && selectedFiles[currentFileIndex].name) {
            currentFileName = selectedFiles[currentFileIndex].name;
        }

        // 当前阶段文本（上传中/处理中）
        let stageText = '正在上传';
        if (isProcessing) {
            stageText = '正在处理（后台响应中）';
        }
        return (
            <Spin spinning={loading}>
                {(
                    uploadStatus === 'uploading' ||
                    uploadStatus === 'success' ||
                    uploadStatus === 'error'
                ) &&
                    <div style={{ width: 400 }}>

                        {/* 上传进度条区域（带取消叉号） */}
                            <div style={{
                                marginTop: 10,
                                padding: 10,
                                border: '1px solid #e8e8e8',
                                borderRadius: 4,
                                position: 'relative'
                            }}>
                                {/* 右上角取消按钮 */}
                                <Icon
                                    type="close"
                                    style={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        cursor: 'pointer',
                                        color: '#999',
                                        fontSize: 14
                                    }}
                                    onClick={this.closeModal}
                                    title="取消上传"
                                />

                                <div style={{ 
                                    marginTop: 5, 
                                    
                                    color: '#666',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}>
                                    <Icon style={{ fontSize: 15 }} type="paper-clip" />{folderName}
                                </div>

                                {/* 当前文件+阶段提示 */}
                                {currentFileIndex >= 0 && (
                                    <div style={{ marginTop: 5, fontSize: 12, color: '#666' }}>
                                        {stageText}：{currentFileName}
                                    </div>
                                )}

                                {/* 整体进度条（上限100%） */}
                                <Progress
                                    percent={percentBySize}
                                    showInfo={false}
                                    strokeWidth={8}
                                    style={{ marginTop: 10, borderRadius: 4 }}
                                    status={isProcessing ? 'active' : 'normal'} // 处理中时进度条保持动画
                                />

                                {/* 进度文本：双维度进度 + 阶段提示 */}
                                <div style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between', marginBottom: 5, fontSize: 12 }}>
                                    <span>{this.props.formatSize(totalUploaded)}/{this.props.formatSize(totalSize)}（{percentBySize}%）</span>
                                    <span>{uploadedFiles}/{totalFiles}&nbsp;&nbsp;已上传</span>
                                </div>

                                {/* 上传成功提示 + 打开按钮 */}
                                {uploadStatus === 'success' && (
                                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Icon type="check-circle" style={{ color: '#52c41a', fontSize: 22 }} />
                                        <span>全部上传成功</span>

                                        <a onClick={this.props.handleOpenFolder}>打开</a>
                                    </div>
                                )}

                                {/* 上传失败提示 */}
                                {uploadStatus === 'error' && (
                                    <div style={{ marginTop: 10, color: '#f5222d' }}>
                                        <Icon type="close-circle" /> 批量上传失败（成功{uploadedFiles}个，失败{failedFiles.length}个）
                                    </div>
                                )}
                            </div>


                    </div>
                }
            </Spin>

        );
    }
}

export default FolderUploadProgress;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/FolderUploadProgress.js